<template>
  <validation-observer ref="simpleRules">
    <b-tabs
      pills
    >
      <b-tab active>
        <template #title>
          <feather-icon icon="BookIcon" />
          <span>Lisans Bilgileri</span>
        </template>
        <licenses-item-form />
        <save-button
          :save-action="submitForm"
          :is-disabled="submitStatus"
        />
      </b-tab>
      <b-tab>
        <template #title>
          <feather-icon icon="PieChartIcon" />
          <span>Kullanım İstatistikleri</span>
        </template>
        <component :is="appComponents.StatisticsCard" />
      </b-tab>
      <b-tab>
        <template #title>
          <feather-icon icon="UserIcon" />
          <span>Kullanıcı Bilgileri</span>
        </template>
        <component :is="appComponents.UsersCard" />
      </b-tab>
    </b-tabs>
  </validation-observer>
</template>
<script>
import { BTabs, BTab } from 'bootstrap-vue'
import SaveButton from '@/layouts/components/common/SaveButton.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { ValidationObserver, localize } from 'vee-validate'
import { required } from '@validations'
import LicensesItemForm from '@/views/Admin/Licenses/ItemForm.vue'
import DrUserList from '@/views/Admin/Licenses/AppUsers/DrUserList.vue'
import DrStatistics from '@/views/Admin/Licenses/UsageStatistics/DrStatistics.vue'

export default {
  name: 'EditPage',
  components: {
    BTabs,
    BTab,
    LicensesItemForm,
    ValidationObserver,
    SaveButton,
    DrUserList,
    DrStatistics,
  },
  data() {
    return {
      required,
      submitStatus: false,
    }
  },
  computed: {
    itemData() {
      return this.$store.getters['licenses/dataItem']
    },
    saveData() {
      return this.$store.getters['licenses/dataSaveStatus']
    },
    appComponents() {
      const response = {
        UsersCard: null,
        StatisticsCard: null,
      }
      if (this.itemData.id_projects === '1') {
        response.UsersCard = 'DrUserList'
        response.StatisticsCard = 'DrStatistics'
      }
      return response
    },
  },
  watch: {
    saveData(val) {
      if (val.status === true) {
        this.showToast({
          variant: 'success', title: 'İşlem Başarılı!', icon: 'CheckIcon', text: val.message,
        })
        this.$router.push('/admin/licenses')
      } else if (val.status === false) {
        this.showToast({
          variant: 'danger', title: 'İşlem Hatası!', icon: 'XIcon', text: val.message,
        })
        this.submitStatus = false
      }
    },
  },
  beforeCreate() {
    this.$store.commit('licenses/RESET_DATA_ITEM')
  },
  created() {
    localize('tr')
    this.getData()
  },
  methods: {
    getData() {
      this.$store.dispatch('licenses/getDataItem', this.$route.params.id)
        .then(response => {
          this.getPackages(response)
          this.getCustomer(response.id_customers)
        })
    },
    getCustomer(id) {
      this.$store.dispatch('customers/getDataItem', id)
    },
    getPackages(data) {
      if (data.id_projects) {
        this.$store.dispatch('projectPackages/getDataList', {
          select: [
            'project_packages.id AS id',
            'project_packages.title AS title',
          ],
          where: {
            'project_packages.id_projects': data.id_projects,
          },
        })
      }
    },
    submitForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          this.submitStatus = true
          this.$store.dispatch('licenses/saveData', this.itemData)
        } else {
          this.showToast({
            title: 'Uyarı!',
            icon: 'XIcon',
            text: 'Lütfen tüm alanları doldurun.',
            variant: 'danger',
          })
        }
      })
    },
    showToast(params) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: params.title,
          icon: params.icon,
          text: params.text,
          variant: params.variant,
        },
      }, {
        position: 'bottom-center',
      })
    },
  },
}
</script>
